import {EventEmitter, inject, Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {Overlay} from "@angular/cdk/overlay";
import {TaskDetailComponent} from "../../components/tasks/task-detail/task-detail.component";
import {BehaviorSubject, Observable, tap} from "rxjs";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ProjectControllerService, Task, TaskControllerService, User} from "../../api";
import {map} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class TaskDetailsService {
  overlay = inject(Overlay);
  private router = inject(Router);
  private taskControllerService = inject(TaskControllerService);
  private projectControllerService = inject(ProjectControllerService);
  private dialog = inject(MatDialog);

  private cachedProjectUsers = new Map<number, User[]>();

  private taskSource = new BehaviorSubject<Task | undefined>(undefined);
  currentTask = this.taskSource.asObservable();

  currentTaskChanged = new EventEmitter<Task>();
  currentTaskDeleted = new EventEmitter<Task>();

  // Offener Task-Dialog (inkl. Schließ-Animation); verhindert einen zweiten Dialog per Doppelklick (#2736).
  private openedDialogRef: MatDialogRef<TaskDetailComponent> | undefined;

  setOpenedTask(task: Task | undefined){
    // Vor taskSource.next: sonst überschreibt der zweite Klick den Task, den der offene Dialog liest.
    if (this.openedDialogRef) {
      return;
    }
    this.taskSource.next(task);
    this.openDialog();
  }

  getOpenedTask(){
    return this.taskSource.getValue();
  }

  clearOpenedTask(){
    this.taskSource.next(undefined);
  }

  closeAndSaveTask(task: Task){
    this.taskSource.next(task);
  }

  openDialog() {
    const ref = this.dialog.open(TaskDetailComponent, {
      panelClass: ['rounded-corners-dialog', 'bic-popup-dialog'],
      data: this.getOpenedTask(),
      hasBackdrop: false
    });
    this.openedDialogRef = ref;
    ref.afterClosed().subscribe(() => {
      if (this.openedDialogRef === ref) {
        this.openedDialogRef = undefined;
      }
    });
  }
  openDialog_ifcViewer() {
    let ref = this.dialog.open(TaskDetailComponent, {
      panelClass: ['rounded-corners-dialog', 'bic-popup-dialog'],
      data: this.getOpenedTask(),
      hasBackdrop: false
    }
  );

  }

  getCachedUsers(projectId: number): User[] {
    return this.cachedProjectUsers.get(projectId) ?? [];
  }

  loadProjectUsers(projectId: number): Observable<User[]> {
    return this.projectControllerService.getUsers(projectId).pipe(
      map(users => users
        .filter(user => user.isActivated)
        .sort((a, b) => {
          if (a.profileImage && !b.profileImage) return -1;
          if (!a.profileImage && b.profileImage) return 1;
          return 0;
        })
      ),
      tap(users => this.cachedProjectUsers.set(projectId, users))
    );
  }
}
